
import AppService from "@/services/integration/AppService";
import LeadService from "@/services/leadService";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BaseLoaderDefault from "@/components/base/BaseLoaderDefault.vue";
import { dateFilter, truncateFilter } from "@/utils/filters";
import { mapGetters } from "vuex";

@Component({
  components: {
    BaseLoaderDefault
  },

  filters: {
    date: dateFilter,
    truncate: truncateFilter
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  },

  methods: {
    hide () {
      this.$emit('hide')
    }
  }
})

export default class ModalMessageApp extends Vue {
  @Prop()
  private idLead;

  @Prop()
  private idLeadHistory;

  @Prop()
  private status;

  @Prop()
  private leadFullName;

  @Prop()
  private leadProduct;

  private loading = false;
  private MessageResult: any = null;
  private typeChat: any = null;
  private CsatResult: any = null;
  private getOpportunityDetails: any = null;
  private getOpportunityDetailsText: any = null;
  private getOpportunityDetailsValue: any = null;
  private SentimentResult: any = null;
  private tabs = "Chat";
  private isDemoPlatform: boolean = this.$auth.user().id_platform === 705

  private cleverTabs: any[] = [
    {
      id: 'clever-tab-jornada',
      label: 'Jornada do Lead',
      isActive: false
    },
    {
      id: 'clever-tab-chat',
      label: 'Chat',
      isActive: true
    },
    {
      id: 'clever-tab-sentimento',
      label: 'Sentimento',
      isActive: true
    },
    {
      id: 'clever-tab-avaliacao',
      label: 'Avaliação',
      isActive: true
    },
    {
      id: 'clever-tab-ligacao',
      label: 'Ligação',
      isActive: false
    }
  ];

  private cleverTabActive: string = '';

  private leadJourney: any[] = [
    {
      id: 1,
      type: 'whatsapp',
      event: 'Conversa com André',
      when: '22/11 às 10:00h',
      tabAction: {
        id: 'clever-tab-chat',
        label: 'Ler conversa'
      }
    },
    {
      id: 2,
      type: 'call',
      event: 'Ligação para André',
      when: '22/11 às 10:00h',
      tabAction: {
        id: 'clever-tab-ligacao',
        label: 'Ouvir áudio'
      }
    },
    {
      id: 3,
      type: 'whatsapp',
      event: 'Conteúdo para nutrição',
      when: '23/11 às 9:30h',
      tabAction: {
        id: 'clever-tab-chat',
        label: 'Ler conversa'
      }
    },
    {
      id: 4,
      type: 'proposal',
      event: 'Envio de proposta',
      when: '23/11 às 12:20h',
      tabAction: null
    },
    {
      id: 5,
      type: 'csat',
      event: 'Pesquisa de satisfação',
      when: '23/11 às 17:00h',
      tabAction: null
    }
  ];

  private AppService = new AppService();
  private leadService = new LeadService();

  @Watch("idLead", { immediate: false, deep: false })
  onidLead(val: any, oldVal: any) {
    if (this.idLead !== null)
      this.getValueModal(this.idLead, this.idLeadHistory);
  }

  private mounted () {
    this.resetCleverTab();
  }

  private async getValueModal(leadId: number, leadHistory: number) {
    this.loading = true;

    this.MessageResult = await this.AppService.getMessageByLead(leadId);

    if (typeof this.MessageResult === 'object' && this.MessageResult.length > 1) {
      this.MessageResult = this.MessageResult.reverse();
    }

    this.SentimentResult = await this.AppService.getSentimentByLead(leadId);
    this.CsatResult = await this.AppService.getCSATByLead(leadHistory);

    if (this.CsatResult && !!this.CsatResult.products) {
      this.getOpportunityDetails = await this.AppService.getOpportunityDetails(
        leadId
      );
      this.getOpportunityDetailsText =
        (typeof this.getOpportunityDetails != "string" &&
        this.getOpportunityDetails.history[
            Object.keys(this.getOpportunityDetails.history)[0]
        ].contents?.filter((e) => e.name == "details").length > 0)
          ? this.getOpportunityDetails.history[
              Object.keys(this.getOpportunityDetails.history)[0]
            ].contents?.filter((e) => e.name == "details")[0].value || ''
          : "";
      this.getOpportunityDetailsValue =
        typeof this.getOpportunityDetails != "string"
          ? this.getOpportunityDetails.history[
              Object.keys(this.getOpportunityDetails.history)[0]
            ].action.label
          : "";
    }

    this.loading = false;
  }

  private getSentimentPercent(sentiment: number) {
    const value =
      (sentiment * 100) /
      (this.SentimentResult.positive_sentiment +
        this.SentimentResult.neutral_sentiment +
        this.SentimentResult.negative_sentiment);
    return parseFloat(value.toFixed(2)) + "%";
  }

  private getPrincipalSentiment() {
    return Math.max.apply(null, [
      this.SentimentResult.positive_sentiment,
      this.SentimentResult.neutral_sentiment,
      this.SentimentResult.negative_sentiment,
    ]);
  }

  private selectCleverTab (event) {
    this.cleverTabActive = event.currentTarget.getAttribute('href').replace(/^#/, '');
  }

  private resetCleverTab () {
    this.cleverTabActive = this.cleverTabs.find(item => item.isActive === true).id;
  }

  private async transhipmentChat() {
    this.loading = true;

    try {
        this.AppService.transhipmentLead(this.idLead).then((res) => {
            JSON.stringify(res).includes("success") ?
                this.$store.commit("navBarAlert/SUCCESS_ALERT", "Transbordado com sucesso!") :
                this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao Transbordar o lead`);
        });

        this.$bvModal.hide('modal-message-app');
        this.$bvModal.hide('modal-confirm');
    } catch (error) {
        this.$bvModal.hide('modal-message-app');
        this.$bvModal.hide('modal-confirm');
        console.log(error);
        this.$store.commit("navBarAlert/DANGER_ALERT", `Ocorreu um erro inesperado, tente novamente`);
    }
  }
}
